"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFINEMENTS_SET_LOADING = exports.REFINEMENTS_SET_DATA = exports.REFINEMENTS_SET_FILTER = void 0;
const const_1 = require("../../const");
exports.REFINEMENTS_SET_FILTER = `${const_1.PREFIX_ENRICH}REFINEMENTS_SET_FILTER`;
exports.REFINEMENTS_SET_DATA = `${const_1.PREFIX_ENRICH}REFINEMENTS_SET_DATA`;
exports.REFINEMENTS_SET_LOADING = `${const_1.PREFIX_ENRICH}REFINEMENTS_SET_LOADING`;
